module.exports = __webpack_public_path__ + "static/img/pie1.778eff7a.jpg";